import React from 'react';
import { useDispatch } from 'react-redux';
import BaseFilter from './BaseFilter';
import useFilter from './useFilter';
// import ActiveListingCheckbox from './filter_components/checkboxes/ActiveListingCheckbox';
import { clearAllAndSearch } from '../../../redux/slices/filterSlice';

const ListingFilter = () => {
  const dispatch = useDispatch();
  const { filters, handleFilterChange } = useFilter();

  const handleClearAll = () => {
    console.log('Clearing all filters and triggering search');
    dispatch(clearAllAndSearch());
  };

  return (
    <div className="w-full overflow-hidden">
      <BaseFilter layout="horizontal" onClearAll={handleClearAll}>
        {/* <ActiveListingCheckbox /> */}
      </BaseFilter>
    </div>
  );
};

export default ListingFilter; 